module.exports = __webpack_public_path__ + "c7caac8bb02b643f77e8a404a227075f.svg";